import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// @mui
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import { withLang } from '_core/hocs/withLang';
import { getVisitorPhotoSrc } from '_core/utils/getVisitorPhotoSrc';
import HtmlView from '_core/components/HtmlView';
import NoteView from '_core/components/NoteView';

import { useProductDetailsStyle } from './productDetailsStyle';

export const RawProductDetails = (props) => {
  const {
    data,
    rootProps,
    className,
    header,
    actions,
    noPhoto,
    noContent,
    noDescription,
    renderHeader,
    renderActions,
    HeaderComponent,
    ActionsComponent,
    getLangString: l
  } = props;

  const classes = useProductDetailsStyle();
  const rootClasses = clsx({
    [classes.root]: true,
    [className]: className != null
  });

  const realHeader =
    typeof renderHeader === 'function' ? (
      renderHeader(data)
    ) : HeaderComponent != null ? (
      <HeaderComponent {...data} />
    ) : (
      header
    );

  return (
    <Card className={rootClasses} {...rootProps}>
      {!noPhoto &&
      data.photo != null &&
      data.photo.path != null &&
      data.photo.id !== 0 ? (
        <CardMedia
          className={classes.media}
          image={getVisitorPhotoSrc(data.photo.path, 'shop')}
          title={l(data.title)}
        />
      ) : null}

      <CardContent className={classes.body}>
        {realHeader}

        {!noDescription && data.description != null ? (
          <Typography variant="h6" className={classes.description}>
            <NoteView>{data.description}</NoteView>
          </Typography>
        ) : null}

        {!noContent && data.content != null ? (
          <Typography variant="body1" className={classes.content}>
            <HtmlView>{data.content}</HtmlView>
          </Typography>
        ) : null}
      </CardContent>

      <CardActions className={classes.actions}>
        {typeof renderActions === 'function' ? (
          renderActions(data)
        ) : ActionsComponent != null ? (
          <ActionsComponent {...data} />
        ) : (
          actions
        )}
      </CardActions>
    </Card>
  );
};

RawProductDetails.displayName = 'RawProductDetails';

RawProductDetails.defaultProps = {};

RawProductDetails.propTypes = {
  // self props
  data: PropTypes.object.isRequired,
  rootProps: PropTypes.object,
  className: PropTypes.string,
  header: PropTypes.node,
  actions: PropTypes.node,
  renderHeader: PropTypes.func,
  renderActions: PropTypes.func,
  HeaderComponent: PropTypes.elementType,
  ActionsComponent: PropTypes.elementType,
  noPhoto: PropTypes.bool,
  noContent: PropTypes.bool,
  noDescription: PropTypes.bool,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired
};

export const ProductDetails = withLang(RawProductDetails);
